import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import allTranslations from '../locales/all.json';

let env = "prod";
if(window.location.hostname === "localhost") {
    env = "dev";
} else if(window.location.hostname === "mential-uat.web.app") {
    env = "uat";
}


i18n
    .use(Backend) // Configurar el backend HTTP

    // detect user language (solo localStorage/cookie; sin navigator para priorizar español por defecto)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: false,
        lng: 'es',
        fallbackLng: 'es',
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `https://storage.googleapis.com/mential-public-assets/localization/webapp/${env}/{{lng}}/translation.json`,
        },
        requestOptions: {
            mode: 'cors',
        },
        detection: {
            order: ['localStorage', 'cookie'],
            caches: ['localStorage', 'cookie'],
        },
    });
['en', 'es', 'pt'].forEach((lng) => {
    if (allTranslations[lng]) i18n.addResourceBundle(lng, 'all', allTranslations[lng], true);
});

// Priorizar español: si no hay idioma guardado o no es uno de los soportados, usar 'es'
const SUPPORTED_LANGS = ['es', 'en', 'pt'];
if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem('i18nextLng');
    if (!stored || !SUPPORTED_LANGS.includes(stored)) {
        i18n.changeLanguage('es');
    }
}

export default i18n;
